/**
 * Route for `google-ads-enhanced-conversions-server-side-hashed`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { GoogleAdsEnhancedConversionsServerSideHashedPage } from "../features/google-ads-enhanced-conversions-server-side-hashed/GoogleAdsEnhancedConversionsServerSideHashedPage";

export const googleAdsEnhancedConversionsServerSideHashedRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/google-ads-enhanced-conversions-server-side-hashed",
	component: GoogleAdsEnhancedConversionsServerSideHashedPage,
});

export default googleAdsEnhancedConversionsServerSideHashedRoute;
